export interface StatementItem {
  id: string;
  description: string;
  amount: number;
  category: string;
}


export enum StatementStatus {
  Draft = 'draft',
  Issued = 'issued',
  Paid = 'paid',
  Overdue = 'overdue',
  Pending = 'pending',
  Cancelled = 'cancelled',
}

export interface Statement {
  id: string;
  ownerId: string;
  buildingId: string;
  unitId: string;
  unitName: string;
  residentName: string;
  residentEmail?: string;
  period: string;
  issueDate: string;
  dueDate: string;
  totalAmount: number;
  items: StatementItem[];
  status: StatementStatus;
  paidAmount?: number;
  paidDate?: string;
  paymentMethod?: string;
  documentUrl?: string;
  notes?: string;
  createdAt: string;
  createdBy: string;
  updatedAt?: string;

  // Service Charge Reconciliation — source tracking (feature: service-charge-reconciliation)
  // Populated when a statement is generated by aggregating FinancialRecords for
  // a building/period. These let a treasurer trace each statement back to the
  // underlying transactions and the categories that contributed to it.

  /** IDs of the FinancialRecords that contributed to this statement. */
  sourceFinancialRecordIds?: string[];
  /** AccountingCategory nominal codes included when generating this statement. */
  sourceCategories?: string[];
  /** Total building-wide charges (in pence) before apportionment to this unit. */
  charges?: number;
  /** Total building-wide payments (in pence) before per-unit attribution. */
  payments?: number;
}


export interface StatementFilters {
  search: string;
  status: StatementStatus | '';
  startDate: string | null;
  endDate: string | null;
  unitId: string;
}
